import React, { forwardRef } from "react";
import "./TextInput.scss";

const TextInput = forwardRef(({ id, label, type = "text", ...rest }, ref) => {
  return (
    <div className="textInput">
      {label && <label htmlFor={id}>{label}</label>}
      <input ref={ref} id={id} type={type} {...rest} />
    </div>
  );
});

export default TextInput;
